import React from 'react'
import { Route, Switch } from 'react-router-dom'
import './container-front.css'

// routes config
import routes from '../routes'
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const TheContent = () => {
  const fadeElementRef = React.useRef(null)

  React.useEffect(() => {
    const fadeElement = fadeElementRef.current
    fadeElement.classList.remove('show')
    setTimeout(() => {
      fadeElement.classList.add('show')
    }, 100)
  }, [])

  return (
    <main>
      <div className="front-container-fluid">
        <React.Suspense fallback={loading}>
          <Switch>
            {routes.map((route, idx) => {
              if (route === null || route === undefined) {
                return null
              }
              if (route?.component === null || route?.component === undefined) {
                return null
              } else {
                return (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={(props) => (
                      <div ref={fadeElementRef} className="front-fade show">
                        {route !== null && <route.component {...props} type={route?.type} />}
                      </div>
                    )}
                  />
                )
              }
            })}
            )
          </Switch>
        </React.Suspense>
      </div>
    </main>
  )
}

export default React.memo(TheContent)
